import React, { useMemo } from 'react';

import { useHistoryOutcomeCardContext } from '../../contexts/HistoryOutcomeCardContext';
import useMergeProps from '../../hooks/useMergeProps';
import useTypedSelector from '../../hooks/useTypedSelector';
import { type OutcomeStatus } from '../../types/history';

import HistoryItemOutcomeContentFactory from './HistoryItemOutcomeContentFactory';
import makeHistoryItemOutcomeContentFactoryPropsSelector from './HistoryItemOutcomeContentFactory.selector';

type HistoryItemOutcomeContentFactoryContainerProps = {
  className?: string;
  outcome: unknown;
  flagId?: string;
  shouldDisplayFlag?: boolean;
  outcomeStatus: OutcomeStatus;
  isSimpleBet?: boolean;
  isUserPrefsCompact?: boolean;
  noBreakLine: boolean;
};

const HistoryItemOutcomeContentFactoryContainer = ({
  outcome,
  ...ownProps
}: HistoryItemOutcomeContentFactoryContainerProps) => {
  const { outcomeStatus } = ownProps;
  const { initialOdds, odds } = useHistoryOutcomeCardContext();

  const selector = useMemo(() => makeHistoryItemOutcomeContentFactoryPropsSelector(), []);
  const selectorProps = useMemo(() => ({ outcome, outcomeStatus }), [outcome, outcomeStatus]);
  const selectedProps = useTypedSelector((state) => selector(state, selectorProps));

  const otherProps = useMemo(() => ({ initialOdds, odds }), [initialOdds, odds]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <HistoryItemOutcomeContentFactory {...enhancedProps} />;
};

export default HistoryItemOutcomeContentFactoryContainer;
